// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"6ed8dabd","103":"6ed8dabd","634":"290a01ed","650":"1c8d905b","856":"80247b32"}[chunkId] + ".chunk.css";
};